module.exports = __webpack_public_path__ + "img/lukinovic.0c02ea94.jpg";